import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';
import SingleOrderDetail from './SingleOrderDetail';

export default styled(SingleOrderDetail)`
  display: flex;
  padding: 0px;

  &.fixed-height {
    height: calc(100vh - 72px);
  }

  &.flexible-height {
    height: 100%;
  }

  .details-column {
    width: 50%;
    overflow-y: scroll;

    ${media.lessThan('medium')`
    width: 60%;
    `}

    ${media.lessThan('small')`
      width: 100%;
    `}
  }

  .details-wrapper {
    width: 496px;
    margin: 0 auto;

    ${media.lessThan('small')`
      width: 98%;
      max-width: 496px;
    `}
  }

  .details-wrapper > div:not(:last-child),
  ul {
    padding: ${gridSizes('M')};

    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
      margin: 4px;
      background: #fff;
      width: initial !important;
      border-radius: 2px;
    `};
  }

  .map-column {
    width: 50%;

    ${media.lessThan('medium')`
    width: 40%;
    `}

    ${media.lessThan('small')`
      display: none;
    `}
  }

  .cancel {
    p {
      margin: 0;
    }
  }

  @media print {
    display: block !important;
    position: inherit !important;
    padding: 0 !important;
    overflow: visible !important;

    margin: 0 !important;
    width: 100vw !important;
    max-width: none !important;

    .content {
      box-shadow: initial !important;
      border-radius: inherit !important;
      padding: initial !important;
      margin: initial !important;
    }

    .details-column {
      width: 100vw !important;
      margin: 0 !important;
    }

    .details-wrapper {
      max-width: none !important;
      width: 100vw !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    button {
      display: none !important;
    }

    .map-column {
      display: none !important;
    }

    .header {
      display: none !important;
    }

    .footer {
      display: none !important;
    }

    .main {
      display: none !important;
    }

    &.fixed-height {
      height: 100%;
    }

    .details-column & > div {
      page-break-inside: avoid;
    }
    .details-column & > ul > li {
      page-break-inside: avoid;
    }
  }
`;
